import { PLCustomerData, PLCustomerExtraInformation } from 'types/plCustomerData';

export const SET_CUSTOMER = 'SET_CUSTOMER';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';
export const SET_CUSTOMER_EXTRA_INFORMATION = 'SET_CUSTOMER_EXTRA_INFORMATION';
export const SET_CUSTOMER_IS_MEMBER = 'SET_CUSTOMER_IS_MEMBER';

export type SetCustomer = {
	type: typeof SET_CUSTOMER;
	payload: PLCustomerData;
};

export type ResetCustomer = {
	type: typeof RESET_CUSTOMER;
};

export type SetCustomerExtraExtraInformation = {
	type: typeof SET_CUSTOMER_EXTRA_INFORMATION;
	payload: PLCustomerExtraInformation;
};

export type SetCustomerIsMember = {
	type: typeof SET_CUSTOMER_IS_MEMBER;
	payload: boolean;
};

export type CustomerActionTypes =
	| SetCustomer
	| ResetCustomer
	| SetCustomerExtraExtraInformation
	| SetCustomerIsMember;
